/**
 * 常用方法封装
 * addyxu
 * 2015-12-10
 */

import Env from './env.js';

import Ajax from '../base/ajax';

// var WX_UTIL = require('../common/wx_util');
import wxBridge from '../jsapis/openUrl';

import Dom from '../base/mdom.js';
/**
 *  获取url中的某个key对应的值
 *  @public
 *  @param  name key名
 *  @return key的名字
 *  @example
 *  location.href = 'http://www.qq.com/r.cgi?te=32&tags=div';
 *  var te = getQueryStr('te'); // te = 32
 *  var tags = getQueryStr('tags'); // te = div
 *
 */
export function getQueryStr(name, str, useTop) {
    "use strict";
    try{
        str = str || (useTop ? Dom.window.location.search : location.search);
    }catch(e){
        str = str || location.search;
    }

    // 兼容wepkg没有票据的情况
    if(str.indexOf('wechat_pkgid=') > -1 && (name === 'uin' || name === 'key' || name === 'pass_ticket')) {
        if(window.wepkgLoginInfo && window.wepkgLoginInfo[name]) {
            return window.wepkgLoginInfo[name]
        }else {
            return '';
        }
    }else {
        var res = str.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
        if (res == null || res.length <= 1) {
            return "";
        }
        return res[1];
    }
}
// 组合登录票据参数
export function getUserLoginParamsStr () {
    return 'uin=' + getQueryStr('uin', '', 1) + '&key=' + getQueryStr('key', '', 1) + '&pass_ticket=' + getQueryStr('pass_ticket', '', 1);
}
// 返回
export function getUserLoginParams () {
    return {
        uin: getQueryStr('uin', '', 1),
        key: getQueryStr('key', '', 1),
        pass_ticket: getQueryStr('pass_ticket', '', 1)
    }
}
function getUserLoginByAccessToken(){
    return mapToStr({
        auth_type: 2,
        m_sig       : getQueryStr('sig') || "",
        m_timestamp : getQueryStr('timestamp') || "",
        m_algorithm : getQueryStr('algorithm') || "",
        m_version   : getQueryStr('version') || "",
        m_encode    : getQueryStr('encode') || "",
        appid       : getQueryStr('appid') || getQueryStr('gamekey') || "",
        m_param     : getQueryStr('msdkEncodeParam') || ""
    })
}

function getUserLoginByAccessTokenParams(){
    return mapToStr({
        auth_type: 2,
        sig       : getQueryStr('sig') || "",
        timestamp : getQueryStr('timestamp') || "",
        algorithm : getQueryStr('algorithm') || "",
        version   : getQueryStr('version') || "",
        encode    : getQueryStr('encode') || "",
        msdkEncodeParam     : getQueryStr('msdkEncodeParam') || ""
    })
}

function getUserLoginByItop() {
    return mapToStr({
        appid: getQueryStr('appid'),
        auth_type: 2,
        algorithm: getQueryStr('algorithm'),
        encode: getQueryStr('encode'),
        channelid: getQueryStr('channelid'),
        nickname: getQueryStr('nickname'),
        gameid: getQueryStr('gameid'),
        os: getQueryStr('os'),
        ts: getQueryStr('ts'),
        version: getQueryStr('version'),
        seq: getQueryStr('seq'),
        sig: getQueryStr('sig'),
        itopencodeparam: getQueryStr('itopencodeparam')
    })
}

export function getInGameLoginByType() {
    return getQueryStr('msdkEncodeParam') && getQueryStr('appid') ? getUserLoginByAccessToken() : getUserLoginByItop()
}

export function getLoginParamsStrByLoginType(m){
    return (getQueryStr('auth_type') !== '2') || getClientInfo().isWechat ?
        getUserLoginParamsStr() :
        (m ? getUserLoginByAccessToken() : getUserLoginByAccessTokenParams());
}
/**
 *  ajax 请求
 *  @public
 *  @param  url 请求的url， 不要带参数
 *  @param  params 请求的传递的参数，keyvalue模式或者json字符串
 *  @param  onSuccess 成功的回调
 *  @param  onFail 失败的回调
 *  @param  options {method: 'GET', timeout: 30000}
 *
 */
export function ajaxRequest(url, params, onSuccess, onFail, options) {
    if(typeof options === 'function'){
        var onTimeout = options;
    }else if(typeof options === 'object'){
        var option = extend({method: 'GET', timeout: 15000}, options);
        onTimeout = arguments[5];
    }else{
        option = {};
    }

    if(url.indexOf("?") === -1){
        url = url + '?';
    }else{
        url = url + '&';
    }
    if(option.method === 'POST'){
        url = url + (getQueryStr('auth_type') === '2' && !getClientInfo().isWechat ? getUserLoginByAccessToken() : getUserLoginParamsStr());
    }else{
        url = url + mapToStr(params) + '&' + (getQueryStr('auth_type') === '2'&& !getClientInfo().isWechat ? getUserLoginByAccessToken() : getUserLoginParamsStr());
    }
    
    this._QMAjax = new Ajax(url, option.method, option.timeout);
    var t0 = (new Date()).getTime();
    this._QMAjax.onComplete = function(xhr) {
        var res = {};
        // 过滤特殊字符
        var temp = (xhr.responseText || '').replace(/[\u0000-\u001f\u000B\u000C\u00A0\uFEFF\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u202E\u202D]/g, '');
        try {
            res = JSON.parse(temp);
        } catch (e) {
            try {
                res = new Function('return ' + temp)();
            } catch (e) {
                res = {};
            }
        }
        onSuccess && onSuccess(res);
        var t1 = (new Date()).getTime();
    };
    this._QMAjax.onError = function(xhr, errcode) {
        if ('ok' !== errcode) {
            onFail && onFail(errcode);
        }                
        var res = {};
        try {
            res = JSON.parse(xhr.responseText)
        } catch (e) {
            res = {responseText: xhr.responseText};
        }
        var t1 = (new Date()).getTime();
    };
    this._QMAjax.onTimeout = onTimeout;

    if ('string' === typeof params) {
        this._QMAjax.send(params);
    } else {
        this._QMAjax.send(mapToStr(params));
    }
    return this._QMAjax;
}
/**
 *  将一个字符串转换为map,用spliter1和spliter2间隔,spliter1 为外围spliter,
 *  @public
 *  @param  str str为fa=33&tes=43&the=ffs
 *          spliter1 外层分隔符 比如 &
 *          spliter2 内层分隔符 比如 =
 *  @return 一个map
 *  @example
 *  var te = 'fa=33&tes=43&the=ffs';;
 *  var tags = strToMap(te); // tags为 {'fa':33,'tes':43,'the':'ffs'};
 *
 */
export function mapToStr(map, spliter1, spliter2) {
    try {
        spliter1 = spliter1 || '&';
        spliter2 = spliter2 || '=';
        var _arr = [];
        for (var p in map) {
            _arr.push(p + spliter2 + map[p]);
        }
        return _arr.join(spliter1);

    } catch (e) {
        alert(e.message);
    }
}
// 扩展
export function extend( defaults, options ) {
    var extended = {};
    var prop;
    for (prop in defaults) {
        if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
            extended[prop] = defaults[prop];
        }
    }
    for (prop in options) {
        if (Object.prototype.hasOwnProperty.call(options, prop)) {
            extended[prop] = options[prop];
        }
    }
    return extended;
};

/**
 *  将一个tpl,map整合为一个字符串。tpl里用{key} 标名要被 map[key] 替换的地方
 *  @public
 *  @param  tpl 带有{key} 的字符串
 *          obj 数据map
            unXss 默认是会xss过滤，如不需要请传true
 *  @return 填充后的字符串。
 *
 */
function formate(tpl, obj, unXss) {
    tpl = tpl + '';
    return tpl.replace(/\{(\w+)\}/g, function (m, n) {
        return obj[n] !== undefined ? (unXss ? obj[n].toString() : filterXSS(obj[n].toString())) : m;
    });
}
export function filterImg(url){
    
    var dev = getQueryStr('debug');
    if(!!dev){
        return url;
    }
    if(isIOS()){
        return url.replace(/^https?\:/i,'');
    }
    url = url.replace(/^\/\//i,'http://');
    return url.replace(/^https\:/i,'http:');



}
// 简单的xss
export function filterXSS(str) {
    return (str || '').toString().replace(/</mg, '&lt;').replace(/>/gm, '&gt;').replace(/\"/gm, '&quot;').replace(/\'/gm, '&#39;');
}
// 终端信息
function getClientInfo(){
    var isDebug = false
    if(!Env.isCSR) {
        isDebug = location.search.indexOf('debug=1') !== -1;
    }
    
    return {
        isIOS: isIOS(),
        isPad: isPad(),
        isAndroid: Env.isAndroid,
        isWechat: Env.isWechat,
        isDebug: isDebug,
        wxVersion: Env.clientVersion(true),
        isWPcWechat: Env.isPcWechat,        
        isPC : Env.isPC
    }
}
// 节流函数，减少函数的调用次数
export function throttle( callback,t,context ){
    var timer;

    return function(){
        var args = arguments;

        clearTimeout( timer );

        timer = setTimeout(function(){
            callback.apply( context,args );
        },t);
    }
}

export function debounce(callback, t, context) {
    var timer;

    return function () {
        var args = arguments;

        if (timer) {
            return;
        }

        timer = setTimeout(function () {
            callback.apply(context, args);
            timer = null;
        }, t)
    }
}

function isIOS(){
    return Env.isiOS;
    // return /(iPhone|iPad|iPod)/i.test(navigator.userAgent)
}

function isPad() {
    return Env.isPad;
    // return /iPad/i.test(navigator.userAgent)
}

function miniProgramNavigateTo(url, param) {
    var basePath = '/pages/webview/webview?';

    if (param) {
        for( var key in param ) {
            basePath += (key+'='+param[key]+'&');
        }
    } else {
        basePath += 'target=h5';
    }

    if ( basePath.slice(-1)[0] != '&' ) {
        basePath += '&';
    }

    WeixinJSBridge.invoke('invokeMiniProgramAPI', {
        name: "navigateTo",
        arg: {
            url: basePath + 'url=' + encodeURIComponent(url),
        }
    }, function(ret){
        console.log(JSON.stringify(ret));
    });
}

// 使用webview打开url
export function openWithWebView(url, param){
    if(Dom.window.__wxjs_environment === "miniprogram"){
        // all url jump webview with target:h5
        if ( window.WeixinJSBridge ) {
            miniProgramNavigateTo(url, param);
        } else {
            window.addEventListener('WeixinJSBridgeReady', function(){
                miniProgramNavigateTo(url, param);
            })
        }
        
    }else{
        // // 为了上报延迟
        // var time = 100;
        // if(getClientInfo().isWPcWechat){
        //     setTimeout(function() {
        //         window.location.href = url;
        //     }, time);
        //     return;
        // }

        // if(Dom.window.WeixinJSBridge) {
        //     Dom.window.WeixinJSBridge.invoke('openUrlWithExtraWebview', {
        //         "url": location.protocol + url.replace(/http(s)?:/, ''),
        //         "openType": "1"
        //     }, function(res) {
        //         if(res.err_msg.indexOf(':ok') == -1){
        //             setTimeout(function() {
        //                 Dom.window.location.href = url;
        //             }, time);
        //         }
        //     });
        // }else{
        //     setTimeout(function() {
        //         window.location.href = url;
        //     }, time);
        // }

        // WX_UTIL.openWithWebView(url);
        wxBridge.openUrl(url)
    }
}
// 微信webview里面设置document的 title （hack）,用之前先授权setPageTitle
export function setTitle(str) {
    var clientInfo = getClientInfo();
    function setTitleByJsAPI(){
        WeixinJSBridge.invoke('setPageTitle', {
            'title': str
        }, function(res){
            // alert(JSON.stringify(res));
        });
    }
    // 去掉安卓的限制，安卓下也使用JSapi设置title
    if(clientInfo.isWechat){
        if(isBigClientVersion('6.0.2') && 
            (clientInfo.isAndroid || (window.__wxjs_is_wkwebview === 'yes' || window.__wxjs_is_wkwebview))){

            if(Dom.window.WeixinJSBridge){

                setTitleByJsAPI();
            }else{
                document.addEventListener('WeixinJSBridgeReady', function () {
                    setTitleByJsAPI();
                });
            }
            return;
        }

        document.title = str;

        if (clientInfo.isWPcWechat) {
            return;
        }

        var iframe = document.createElement('iframe');
        iframe.style.cssText = 'width:0px;height:0px;display:none;';
        iframe.src = location.protocol + '//wximg.gtimg.com/tmt/game/dist/img/wgui/placeholder/1x1.png';
        iframe.onload = function() {
            setTimeout(function() {
                iframe.onload = null;
                document.body.removeChild(iframe);
            }, 0);
        };
        document.body.appendChild(iframe);
    }else{
        document.title = str;
    }
}

export function base64_decode(data) {
  //  discuss at: http://phpjs.org/functions/base64_decode/
  // original by: Tyler Akins (http://rumkin.com)
  // improved by: Thunder.m
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  //    input by: Aman Gupta
  //    input by: Brett Zamir (http://brett-zamir.me)
  // bugfixed by: Onno Marsman
  // bugfixed by: Pellentesque Malesuada
  // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  //   example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==');
  //   returns 1: 'Kevin van Zonneveld'
  //   example 2: base64_decode('YQ===');
  //   returns 2: 'a'

  var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
    ac = 0,
    dec = '',
    tmp_arr = [];

  if (!data) {
    return data;
  }

  data += '';

  do { // unpack four hexets into three octets using index points in b64
    h1 = b64.indexOf(data.charAt(i++));
    h2 = b64.indexOf(data.charAt(i++));
    h3 = b64.indexOf(data.charAt(i++));
    h4 = b64.indexOf(data.charAt(i++));

    bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;

    o1 = bits >> 16 & 0xff;
    o2 = bits >> 8 & 0xff;
    o3 = bits & 0xff;

    if (h3 == 64) {
      tmp_arr[ac++] = String.fromCharCode(o1);
    } else if (h4 == 64) {
      tmp_arr[ac++] = String.fromCharCode(o1, o2);
    } else {
      tmp_arr[ac++] = String.fromCharCode(o1, o2, o3);
    }
  } while (i < data.length);

  dec = tmp_arr.join('');

  return dec.replace(/\0+$/, '');
}
// otherVersion 6.2.23   UA: 6.2.25  return true
// otherVersion 6.2.23   UA: 6.2.22  return false
// otherVersion 6.3.2   UA: 6.2.25  return false    
// otherVersion 6.1.25   UA: 6.2.25  return false        
export function isBigClientVersion(otherVersion){
    var mat = (navigator.userAgent || navigator.wxuserAgent || str).match(/MicroMessenger\/([\d\.]+)/i),
        version = '';

    if (mat && mat.length > 1) {
        version = mat[1];
    }else{
        return false;
    }
    
    version = version.split('.');
    otherVersion = otherVersion.split('.');

    for(var i = 0; i < version.length && i < otherVersion.length; i++){
        if((+version[i] || 0) > (+otherVersion[i] || 0)){
            return true;
        }else if((+version[i] || 0) < (+otherVersion[i] || 0)){
            return false;
        }
    }
    return false;
}

/**
 * 在字符串中去掉含有filterKeys中的key且为空的项，返回处理后的字符串
 * 
 * @param {string} url 
 * @param {array} filterKeys 
 * @returns {string}
 */
export function filterUrlByKey(url, filterKeys) {
    filterKeys.forEach(function(fkey, i) {
        var keyReg = new RegExp("[\?\&](" + fkey + "=([^\&]*))", "i");
        var res = url.match(keyReg);
        if ( res && res.length > 2 
            && (res[2] == '' || res[2] == 'undefined' || res[2] == '0') ) {
                url = url.replace(res[1], '')
                        .replace(/(\?|\&)\&/g, '$1');
        }
    })

    return url;
}

/**
 * 在对象中去掉含有filterKeys中的key且为空的项，返回处理过后的对象
 * 
 * @param {object} paramObj 
 * @param {array} filterKeys 
 * @returns {object}
 */
export function filterParamByKey(paramObj, filterKeys) {
    filterKeys.forEach(function(fkey, i) {
        if (paramObj.hasOwnProperty(fkey)) {
            var val = paramObj[fkey];

            if ( val == null 
                || val == undefined 
                || val == '' || val == 0 || val == '0' ) {
                delete paramObj[fkey];
            }
        }
    })

    return paramObj;
}

export default {
    getQueryStr:                getQueryStr,
    getUserLoginParamsStr:      getUserLoginParamsStr,
    getUserLoginParams:         getUserLoginParams,
    mapToStr:                   mapToStr,
    ajaxRequest:                ajaxRequest,
    extend:                     extend,
    tmpl:                       formate,
    filterXSS:                  filterXSS,
    clientInfo:                 getClientInfo(),
    throttle:                   throttle,
    openWithWebView:            openWithWebView,
    setTitle:                   setTitle,
    base64_decode:              base64_decode,
    isBigClientVersion:         isBigClientVersion,
    getLoginParamsStrByLoginType: getLoginParamsStrByLoginType,
    getInGameLoginByType:       getInGameLoginByType,
    filterImg:                  filterImg,
    filterParamByKey:           filterParamByKey,
    filterUrlByKey:             filterUrlByKey,
    debounce:                   debounce,
};
export const tmpl = formate;
export const clientInfo = getClientInfo();